module.exports = __webpack_public_path__ + "img/Addedo.94c85be5.png";